var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import EmojiWithText from "@irati/ui/src/EmojiWithText";
import { Para } from "@irati/ui/src/Labels";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
var StyledPara = styled(Para)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 30px;\n"], ["\n  margin-bottom: 30px;\n"])));
var FeaturesContent = /** @class */ (function (_super) {
    __extends(FeaturesContent, _super);
    function FeaturesContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeaturesContent.prototype.render = function () {
        var formatMessage = this.props.formatMessage;
        return (React.createElement(React.Fragment, null,
            React.createElement(StyledPara, { large: true },
                React.createElement(FormattedMessage, { id: "medical.code.features.title" })),
            React.createElement(EmojiWithText, { emoji: "iphone", text: formatMessage({ id: "medical.code.features.text1" }) }),
            React.createElement(EmojiWithText, { emoji: "date", text: formatMessage({ id: "medical.code.features.text2" }) }),
            React.createElement(EmojiWithText, { emoji: "ok_hand", text: formatMessage({ id: "medical.code.features.text3" }) }),
            React.createElement(EmojiWithText, { emoji: "video_camera", text: formatMessage({ id: "medical.code.features.text4" }) })));
    };
    return FeaturesContent;
}(PureComponent));
export default injectIntl(FeaturesContent);
var templateObject_1;
